/**
 * スクロールバーを除いた横幅を取得してCSS変数に設定する
 */
const setViewportWidthVariable = () => {
  const getViewportWidth = () => {
    // documentElement.clientWidthでスクロールバーを除いた横幅を取得
    const viewportWidth = document.documentElement.clientWidth;

    // CSS変数に設定
    document.documentElement.style.setProperty(
      '--js-width__viewport',
      `${viewportWidth}px`,
    );
  };

  // 初期設定
  getViewportWidth();

  // ページ読み込み完了後に再計算（レイアウトが安定してから）
  window.addEventListener('load', () => {
    setTimeout(getViewportWidth, 50);
  });

  // ウィンドウリサイズ時に再計算（スクロールバーの表示/非表示が変わる可能性があるため）
  window.addEventListener('resize', getViewportWidth);
};

export { setViewportWidthVariable };
